import { Image, Typography } from 'antd';
import { startCase } from 'es-toolkit';
import { ReactComponent as RightArrow } from '../../../Assets/rightCircle-arrow.svg';
import {
  formatToINR,
  getNudgeDescription,
  nudgesLogo,
} from '../../../Utils/utils';
import { getImagePath } from '../../../Utils/assetUtils';
import styles from './index.module.css';

const NudgeItem: React.FC<{
  nudge: any;
  isNotClickable?: boolean;
}> = ({ nudge, isNotClickable }) => {
  const handleImageError = (event: any) => {
    event.target.src = getImagePath('images/categoryIcons/OTHERS.svg');
  };

  return (
    <div className={styles.insightContainer}>
      <div style={{ display: 'flex', gap: 8, flex: 1 }}>
        <div
          style={{
            width: 24,
            height: 24,
            background: '#F2F7FF',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={getImagePath('images/categoryIcons/' + nudgesLogo[nudge.category] + '.svg')}
            onError={handleImageError}
            style={{ height: 16, width: 16 }}
          />
        </div>

        <Typography.Text
          style={{
            fontSize: 14,
            fontWeight: 600,
            flex: 1,
            color: '#373A3E',
          }}
        >
          {nudge.title ? nudge.title : startCase(nudge.category)}
          <Typography.Text className={styles.nudgeDiscription}>
            {nudge.body
              ? nudge.body
              : getNudgeDescription(nudge).replace(
                  /₹XXX/g,
                  formatToINR(
                    nudge.parameter.filter(
                      (para: any) => para.name === 'amount'
                    ).length > 0 &&
                      nudge.parameter.filter(
                        (para: any) => para.name === 'amount'
                      )[0].value
                      ? nudge.parameter
                          .filter((para: any) => para.name === 'amount')[0]
                          .value.toString()
                      : '0'
                  )
                )}
          </Typography.Text>
        </Typography.Text>
      </div>

      {!isNotClickable && <RightArrow />}
    </div>
  );
};
export default NudgeItem;
